import CircularProgress from "@mui/material/CircularProgress";
import axios from "axios";
import React, { useEffect, useState } from "react";
import {
    COUNTRY_URL,
    EVENT_ASSOCIATE_URL,
    EVENT_FORMAT_URL,
    EVENT_TYPE_URL,
    EVENT_DETAILS_DASHBOARD,
    EVENT_DETAILS_BY_ASSOCIATE,
    EVENT_DETAILS_BY_COUNTRY
} from '../ApiDetails.js';
import MapComponent from '../Dashboard/DashBoardMap.jsx';
import Header from "../HeaderAdmin.js";
import Navbar from "../Navbar.js";
import CountryList from "./Countrybar.jsx";
import VirtualEvent from "./VirtualEvents.jsx";

const DashBoard = () => {
    const [assoSegment, setAssoSegment] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [inPersonEvents, setInPersonEvents] = useState([]); // New state for in-person only events
    const [totalEventCount, setTotalEventCount] = useState(0);
    const [countriesVisited, setCountriesVisited] = useState(0);
    const [totalAssociatesAtEvent, setTotalAssociatesAtEvent] = useState(0);
    const [countryFilters, setCountryFilters] = useState([]);
    const [eventTypeFilters, setEventTypeFilters] = useState([]);
    const [eventFormatFilters, setEventFormatFilters] = useState([]);

    const [navBarMltValue, setNavBarMltValue] = useState(false);
    const [reportsFilter, setReportsFilter] = useState({
        selectedCountry: "All",
        selectedAssociate: "All",
        selectedSite: "All",
        selectedStatus: "All",
        selectedEventType: "All",
        selectedEventFormat: "All",
        startDate: "",
        endDate: "",
        mltEvent: navBarMltValue,
    });
    const [eventCountAssociates, setAssociatesEventCount] = useState([]);
    const [virtualEventData, setVirtualEvent] = useState([]);
    const [countrybarData, setFilterCountryBar] = useState([]);

    const element = document.getElementById("navBarMltValue");
    if (element) {
        element.addEventListener("change", () => {
            setNavBarMltValue(element.checked);
        });
    }

    useEffect(() => {
        const fetchDataOnPageLoad = async () => {
            setIsLoading(true);
            try {
                const response = await axios.get(EVENT_DETAILS_DASHBOARD);
                if (response.data.length > 0) {

                    setTotalEventCount(response.data[0].totalEventCount);  // Retains total count
                    setCountriesVisited(response.data[0].countriesVisited);  // Retains countries visited count
                    setTotalAssociatesAtEvent(response.data[0].totalAssociatesAtEvent);  // Retains total associates

                    // Set in-person events for the map
                    const filteredInPersonEvents = response.data.filter(
                        event => event.eventFormat === "In-person only"
                    );

                    setInPersonEvents(filteredInPersonEvents);  // This stays the same
                }
            } catch (error) {
                console.error("Error fetching initial data:", error);
            } finally {
                setIsLoading(false);
            }
        };

        // Fetch initial data on page load
        fetchDataOnPageLoad();
    }, []);


    useEffect(() => {
        const fetchData = async () => {
            try {
                const [
                    countryResponse,
                    eventTypeResponse,
                    eventFormatResponse,
                    eventVirtualResponse,
                    asoociateResponse,
                    countrybarResponse
                ] = await Promise.all([
                    axios.get(COUNTRY_URL),
                    axios.get(EVENT_TYPE_URL),
                    axios.get(EVENT_FORMAT_URL),
                    axios.get(EVENT_DETAILS_DASHBOARD),
                    axios.get(EVENT_DETAILS_BY_ASSOCIATE),
                    axios.get(EVENT_DETAILS_BY_COUNTRY)
                ]);
                setCountryFilters(countryResponse.data);
                setEventTypeFilters(eventTypeResponse.data);
                setEventFormatFilters(eventFormatResponse.data);
                setVirtualEvent(eventVirtualResponse.data);
                setAssociatesEventCount(asoociateResponse.data);
                setFilterCountryBar(countrybarResponse.data);

                // Fetch and filter In-Person only events
                const inPersonResponse = await axios.get(EVENT_DETAILS_DASHBOARD);
                const filteredInPersonEvents = inPersonResponse.data.filter(event => event.eventFormat === "In-person only");

                setInPersonEvents(filteredInPersonEvents); // Save filtered in-person events

            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        fetchData();
    }, []);

    useEffect(() => {
        handleApplyFilterClick();
    }, [navBarMltValue]);

    const handleApplyFilterClick = async () => {
        setIsLoading(true);
        try {
            const {
                selectedCountry,
                selectedAssociate,
                selectedSite,
                selectedStatus,
                selectedEventType,
                selectedEventFormat,
                startDate,
                endDate,
            } = reportsFilter;

            const filterParams = new URLSearchParams();

            if (selectedCountry && selectedCountry !== "All") filterParams.append("Country", selectedCountry);
            if (selectedAssociate && selectedAssociate !== "All") filterParams.append("Associate", selectedAssociate);
            if (selectedSite && selectedSite !== "All") filterParams.append("Site", selectedSite.split(" ")[0]);
            if (selectedStatus && selectedStatus !== "All") filterParams.append("Status", selectedStatus);
            if (selectedEventType && selectedEventType !== "All") filterParams.append("Type", selectedEventType);
            if (selectedEventFormat && selectedEventFormat !== "All") filterParams.append("Formate", selectedEventFormat);
            if (startDate) filterParams.append("StartDate", startDate);
            if (endDate) filterParams.append("EndDate", endDate);
            filterParams.append("MLTSwitch", navBarMltValue);
            const apiUrl = `${EVENT_DETAILS_DASHBOARD}${filterParams.toString() ? `?${filterParams.toString()}` : ""}`;
            const contryapiUrl = `${EVENT_DETAILS_BY_COUNTRY}${filterParams.toString() ? `?${filterParams.toString()}` : ""}`
            const associateapiUrl = `${EVENT_DETAILS_BY_ASSOCIATE}${filterParams.toString() ? `?${filterParams.toString()}` : ""}`

            const [response, countryApiResponse, associateApiResponse] = await Promise.all([
                axios.get(apiUrl),
                axios.get(contryapiUrl),
                axios.get(associateapiUrl)
            ]);

            if (response.data.length > 0) {
                setVirtualEvent(response.data);
                setTotalAssociatesAtEvent(response.data[0].totalAssociatesAtEvent);
                setCountriesVisited(response.data[0].countriesVisited);
                setTotalEventCount(response.data[0].totalEventCount);
                const filteredInPersonEvents = response.data.filter(
                    event => event.eventFormat === "In-person only"
                );
                setInPersonEvents(filteredInPersonEvents);
            } else {
                setVirtualEvent([]);
                setTotalAssociatesAtEvent([]);
                setCountriesVisited([]);
                setTotalEventCount([])
                setInPersonEvents([]);
            }

            if (countryApiResponse.data.length > 0) {
                setFilterCountryBar(countryApiResponse.data);
            } else {
                setFilterCountryBar([]);
            }

            if (associateApiResponse.data.length > 0) {
                setAssociatesEventCount(associateApiResponse.data);
            } else {
                setAssociatesEventCount([]);
            }

        } catch (error) {
            console.error("Error fetching filtered event details:", error);
        } finally {
            setIsLoading(false);
        }
    };


    const handleClearAllFilters = async () => {
        try {
            setReportsFilter({
                selectedCountry: "All",
                selectedAssociate: "All",
                selectedSite: "All",
                selectedStatus: "All",
                selectedEventType: "All",
                selectedEventFormat: "All",
                startDate: "",
                endDate: "",
            });
            const filterclearResponse = await axios.get(EVENT_DETAILS_DASHBOARD);
            setVirtualEvent(filterclearResponse.data);
            const filteredInPersonEvents = filterclearResponse.data.filter(
                event => event.eventFormat === "In-person only"
            );
            setInPersonEvents(filteredInPersonEvents);
            setTotalEventCount(filterclearResponse.data[0].totalEventCount)
            setCountriesVisited(filterclearResponse.data[0].countriesVisited);
            setTotalAssociatesAtEvent(filterclearResponse.data[0].totalAssociatesAtEvent);

            const associateapiUrlResponse = await axios.get(EVENT_DETAILS_BY_ASSOCIATE);
            setAssociatesEventCount(associateapiUrlResponse.data)

            const contryapiUrlResponse = await axios.get(EVENT_DETAILS_BY_COUNTRY);
            setFilterCountryBar(contryapiUrlResponse.data);
        } catch (error) {
            console.error("Error fetching filtered event details:", error);
        }
    };

    // Fetch Assosiate Segments
    useEffect(() => {
        const fetchAssociateSegment = async () => {
            try {
                const response = await axios.get(EVENT_ASSOCIATE_URL);
                setAssoSegment(response.data);
            } catch (error) {
                console.error("Error fetching family members:", error);
            }
        };
        fetchAssociateSegment();
    }, []);

    useEffect(() => {
        localStorage.setItem("reportsFilter", JSON.stringify(reportsFilter));
    }, [reportsFilter]);

    const totalAssociatesCount = eventCountAssociates.reduce((sum, item) => {
        return sum + (item.associateCount || 0);
    }, 0);

    return (
        <div>
            <Header />
            <div>
                <Navbar />
                <div
                    style={{
                        filter: isLoading ? "blur(2px)" : "none",
                        transition: "filter 0.3s ease",
                    }}
                >
                    <div className="single-card-container">
                        <div style={{ padding: "15px", borderRadius: "8px" }} className="cards">
                            <div style={{ margin: "-8px", padding: "0px" }} className="row">
                                <div className="bd-highlight">
                                    <div className="p-1 flex-fill bd-highlight">
                                        <h4 style={{ fontWeight: "bold", color: "#0000a0", fontSize: "14px" }}>Dashboard</h4>
                                    </div>
                                    <div className="p-2 col-20 d-flex align-content-start flex-wrap">
                                        <div className="col-12">
                                            <div className="row mb-3">
                                                <div className="col-md-3">
                                                    <div className="input-group mb-0">
                                                        <label
                                                            className="input-group-text input-group-text-custom dashboardInputFilterLabel"
                                                            htmlFor="country"
                                                        >
                                                            COUNTRY
                                                        </label>
                                                        <select
                                                            style={{
                                                                border: "none",
                                                                fontSize: "11px",
                                                                color: "#0012a5",
                                                                width: "130px",
                                                                outline: "none",
                                                                backgroundColor: "#f4f4fc",
                                                                padding: "10px 20px",
                                                                borderRadius: "8px",
                                                            }}
                                                            className="form-select form-select-sm"
                                                            aria-label="Country"
                                                            id="country"
                                                            value={reportsFilter.selectedCountry}
                                                            onChange={(e) => {
                                                                setReportsFilter({
                                                                    ...reportsFilter,
                                                                    selectedCountry: e.target.value,
                                                                });
                                                            }}
                                                        >
                                                            <option value="All">All</option>
                                                            {countryFilters.length > 0 &&
                                                                countryFilters.map((countryName, index) => (
                                                                    <option key={index} value={countryName}>
                                                                        {countryName}
                                                                    </option>
                                                                ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="input-group mb-0">
                                                        <label
                                                            className="input-group-text input-group-text-custom dashboardInputFilterLabel"
                                                            htmlFor="eventType"
                                                        >
                                                            EVENT TYPE
                                                        </label>
                                                        <select
                                                            style={{
                                                                border: "none",
                                                                fontSize: "11px",
                                                                color: "#0012a5",
                                                                width: "130px",
                                                                outline: "none",
                                                                backgroundColor: "#f4f4fc",
                                                                padding: "10px 20px",
                                                                borderRadius: "8px",
                                                            }}
                                                            className="form-select form-select-sm"
                                                            aria-label="Event Type"
                                                            id="eventType"
                                                            value={reportsFilter.selectedEventType}
                                                            onChange={(e) => {
                                                                setReportsFilter({
                                                                    ...reportsFilter,
                                                                    selectedEventType: e.target.value,
                                                                });
                                                            }}
                                                        >
                                                            <option value="All">All</option>
                                                            {eventTypeFilters.length > 0 &&
                                                                eventTypeFilters.map((eventName, index) => (
                                                                    <option key={index} value={eventName}>
                                                                        {eventName}
                                                                    </option>
                                                                ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="input-group mb-0">
                                                        <label
                                                            className="input-group-text input-group-text-custom dashboardInputFilterLabel"
                                                            htmlFor="eventFormat"
                                                        >
                                                            EVENT FORMAT
                                                        </label>
                                                        <select
                                                            style={{
                                                                border: "none",
                                                                fontSize: "11px",
                                                                color: "#0012a5",
                                                                width: "130px",
                                                                outline: "none",
                                                                backgroundColor: "#f4f4fc",
                                                                padding: "10px 20px",
                                                                borderRadius: "8px",
                                                            }}
                                                            className="form-select"
                                                            aria-label="Event Format"
                                                            id="eventFormat"
                                                            value={reportsFilter.selectedEventFormat}
                                                            onChange={(e) => {
                                                                setReportsFilter({
                                                                    ...reportsFilter,
                                                                    selectedEventFormat: e.target.value,
                                                                });
                                                            }}
                                                        >
                                                            <option value="All">All</option>
                                                            {eventFormatFilters.length > 0 &&
                                                                eventFormatFilters.map((formatName, index) => (
                                                                    <option key={index} value={formatName}>
                                                                        {formatName}
                                                                    </option>
                                                                ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-3 text-end">
                                                    <div style={{ display: "flex", marginTop: "0px" }}>
                                                        <button style={{ marginRight: "10px", fontSize: "10px" }} className="btn-primary-custom p-1 mt-8" onClick={handleApplyFilterClick}>
                                                            Apply Filters
                                                        </button>

                                                        <button style={{ fontSize: "10px" }} className="btn-secondary-custom" onClick={handleClearAllFilters}>
                                                            Clear All
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row mt-3">
                                                <div className="col-md-3">
                                                    <div className="input-group mb-0">
                                                        <label
                                                            className="input-group-text input-group-text-custom dashboardInputFilterLabel"
                                                            htmlFor="associateSegment"
                                                        >
                                                            ASSOCIATES
                                                        </label>
                                                        <select
                                                            style={{
                                                                border: "none",
                                                                fontSize: "11px",
                                                                color: "#0012a5",
                                                                width: "130px",
                                                                outline: "none",
                                                                backgroundColor: "#f4f4fc",
                                                                padding: "10px 20px",
                                                                borderRadius: "8px",
                                                            }}
                                                            className="form-select"
                                                            aria-label="Associate's Segment"
                                                            id="associateSegment"
                                                            value={reportsFilter.selectedAssociate}
                                                            onChange={(e) => {
                                                                setReportsFilter({
                                                                    ...reportsFilter,
                                                                    selectedAssociate: e.target.value,
                                                                });
                                                            }}
                                                        >
                                                            <option value="All">All</option>
                                                            {assoSegment.length > 0 &&
                                                                assoSegment.map((asso, index) => (
                                                                    <option key={index} value={asso}>
                                                                        {asso}
                                                                    </option>
                                                                ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="input-group mb-0">
                                                        <label
                                                            className="input-group-text input-group-text-custom dashboardInputFilterLabel"
                                                            htmlFor="startDate"
                                                        >
                                                            START DATE
                                                        </label>
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                backgroundColor: "#f4f4fc",
                                                                padding: "8px 20px",
                                                                borderRadius: "8px",
                                                            }}
                                                        >
                                                            <input
                                                                type="date"
                                                                style={{
                                                                    border: "none",
                                                                    backgroundColor: "transparent",
                                                                    fontSize: "11px",
                                                                    color: "#0012a5",
                                                                    width: "95px",
                                                                    marginLeft: "5px",
                                                                    outline: "none",
                                                                }}
                                                                id="startDate"
                                                                value={reportsFilter.startDate} // Bind value to state
                                                                onChange={(e) => {
                                                                    setReportsFilter({
                                                                        ...reportsFilter,
                                                                        startDate: e.target.value,
                                                                    });
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="input-group mb-0">
                                                        <label
                                                            className="input-group-text input-group-text-custom dashboardInputFilterLabel"
                                                            htmlFor="startDate"
                                                        >
                                                            END DATE
                                                        </label>
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                backgroundColor: "#f4f4fc",
                                                                padding: "8px 20px",
                                                                borderRadius: "8px",
                                                            }}
                                                        >
                                                            <input
                                                                type="date"
                                                                style={{
                                                                    border: "none",
                                                                    backgroundColor: "transparent",
                                                                    fontSize: "11px",
                                                                    color: "#0012a5",
                                                                    width: "95px",
                                                                    marginLeft: "5px",
                                                                    outline: "none",
                                                                }}
                                                                id="endDate"
                                                                value={reportsFilter.endDate} // Bind value to state
                                                                onChange={(e) => {
                                                                    setReportsFilter({
                                                                        ...reportsFilter,
                                                                        endDate: e.target.value,
                                                                    });
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>



                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Display Map and Calendar */}
                <div className="container-fluid">
                    <div
                        className="progress d-flex flex-column progress-dashboard"
                        style={{ backgroundColor: "#f5f5fb", height: "30%" }} //, height: "30%" 
                    >
                        <div className="row">
                            <div className="col-md-3" style={{ minHeight: "500px" }}>
                                <VirtualEvent virtualEventData={virtualEventData} />
                            </div>
                            <div className="col-md-9" style={{ height: "500px" }}>
                                <MapComponent siteCodes={inPersonEvents} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-9"
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginTop: "36px",
                        marginRight: "10px",
                        marginLeft: "10px"
                    }}
                >
                    <div
                        style={{
                            flex: 1,
                            textAlign: "left",
                            padding: "16px",
                            border: "1px solid #eaeaea",
                            backgroundColor: "#fff",
                            borderRadius: "8px",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                        }}
                    >
                        <div
                            style={{ fontSize: "13px", fontWeight: "bold", color: "#0000a0" }}
                        >
                            TOTAL EVENTS <br />  {totalEventCount}
                        </div>
                    </div>
                    <div
                        style={{
                            flex: 1,
                            marginLeft: "20px",
                            textAlign: "left",
                            padding: "16px",
                            border: "1px solid #eaeaea",
                            backgroundColor: "#fff",
                            borderRadius: "8px",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                        }}
                    >
                        <div
                            style={{ fontSize: "13px", fontWeight: "bold", color: "#0000a0" }}
                        >
                            COUNTRIES VISITED <br /> {countriesVisited}
                        </div>
                    </div>
                    <div
                        style={{
                            flex: 1,
                            marginLeft: "20px",
                            textAlign: "left",
                            padding: "16px",
                            border: "1px solid #eaeaea",
                            backgroundColor: "#fff",
                            borderRadius: "8px",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                        }}
                    >
                        <div
                            style={{ fontSize: "13px", fontWeight: "bold", color: "#0000a0" }}
                        >
                            TOTAL ASSOCIATES AT EVENTS <br /> {totalAssociatesCount}
                        </div>
                    </div>
                </div>

                <div className="col-md-12">
                    <CountryList totalEventCount={totalEventCount} countrybarData={countrybarData} eventCountAssociates={eventCountAssociates} totalAssociatesAtEvent={totalAssociatesAtEvent} totalAssociatesCount={totalAssociatesCount} />

                </div>
                {isLoading && (
                    <div
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100vw",
                            height: "100vh",
                            backgroundColor: "rgba(255, 255, 255, 0.1)", // Semi-transparent background
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            zIndex: 9999, // Ensure the loader is on top of everything
                        }}
                    >
                        <CircularProgress />
                    </div>
                )}
            </div>
        </div>
    );
};

export default DashBoard;
